/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

import classNames from 'classnames';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import classes from './styles.module.scss';

export default function KebabMenu({
  options = [],
  disabled,
  variant = 'normal',
}) {
  const [isVisible, setIsVisible] = useState(false);
  const rootRef = useRef();
  const menuRef = useRef();
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useOnClickOutside(rootRef, () => setIsVisible(false), menuRef);

  const toggle = () => {
    if (disabled) return;
    setIsVisible((v) => {
      const next = !v;
      if (next && rootRef.current) {
        const { left: triggerLeft, bottom: triggerBottom } =
          rootRef.current.getBoundingClientRect();
        const menuWidth = 200;
        const padding = 8;
        let left = triggerLeft;
        left = Math.min(left, window.innerWidth - menuWidth - padding);
        left = Math.max(left, padding);
        const top = triggerBottom + 6;
        setCoords({ top, left });
      }
      return next;
    });
  };

  const menu = (
    <ul
      ref={menuRef}
      className={classNames(classes.menu)}
      style={{
        position: 'fixed',
        top: coords.top,
        left: coords.left,
        zIndex: 10050,
        visibility: isVisible ? 'visible' : 'hidden',
        minWidth: 180,
      }}
    >
      {options.map((opt) => (
        <li
          key={opt.value}
          className={classNames({
            [classes.hidden]: opt.hidden,
            [classes.danger]: opt.danger,
            [classes.withDivider]: opt.withDivider,
            [classes.disabled]: opt.disabled,
            [classes.warning]: opt.warning,
            [classes.success]: opt.success,
          })}
          onClick={() => {
            if (opt.disabled) return;
            setIsVisible(false);
            if (opt.onClick) opt.onClick();
          }}
        >
          {opt.label}
        </li>
      ))}
    </ul>
  );

  return (
    <div className={classes.KebabMenu} ref={rootRef}>
      <button
        type="button"
        className={classNames(classes.trigger, {
          [classes.small]: variant === 'small',
        })}
        onClick={toggle}
        aria-label="More options"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="5" r="2" fill="#242833" />
          <circle cx="12" cy="12" r="2" fill="#242833" />
          <circle cx="12" cy="19" r="2" fill="#242833" />
        </svg>
      </button>
      {isVisible && createPortal(menu, document.body)}
    </div>
  );
}
